import { useThemeStyles } from 'components/_hooks'
import stylesDark from './DropDownTableDark.module.scss'
import stylesLight from './DropDownTableLight.module.scss'

export const useDropDownTableStyles = () => {
  const styles = useThemeStyles(stylesDark, stylesLight)
  return styles
}
